import { render, staticRenderFns } from "./CheckboxSelector.vue?vue&type=template&id=d57068a2&"
import script from "./CheckboxSelector.vue?vue&type=script&lang=js&"
export * from "./CheckboxSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports